import { roleSchema } from '@veem/schema'
import { z } from 'zod'

export const decimalStringSchema = z.string().regex(/^-?\d+(\.\d+)?$/)
export const timestampSchema = z.string().refine((value) => Number.isFinite(Date.parse(value)))
export const versionedRecordSchema = z.object({
  id: z.string().min(1),
  version: z.number().int().positive(),
})
export const directoryPersonSchema = z.object({
  id: z.string().min(1),
  name: z.string(),
  role: roleSchema,
  title: z.string(),
  workCenter: z.string().nullable(),
  workCenters: z.array(z.string()),
  disabledAt: timestampSchema.nullable(),
})
export type DirectoryPerson = z.infer<typeof directoryPersonSchema>
export const taskRecordSchema = versionedRecordSchema.extend({
  dealId: z.string().nullable(),
  linkedEntityType: z.string().nullable(),
  linkedEntityId: z.string().nullable(),
  title: z.string(),
  type: z.enum(['call', 'email', 'meeting', 'task']),
  priority: z.enum(['low', 'normal', 'high', 'urgent']),
  notes: z.string().nullable(),
  assigneeId: z.string(),
  creatorId: z.string(),
  dueAt: timestampSchema.nullable(),
  reminderAt: timestampSchema.nullable(),
  status: z.enum(['open', 'completed', 'cancelled']),
  completedAt: timestampSchema.nullable(),
  cancelledAt: timestampSchema.nullable(),
  createdAt: timestampSchema,
  updatedAt: timestampSchema,
})
export type TaskRecord = z.infer<typeof taskRecordSchema>
export const statusRecordSchema = versionedRecordSchema.extend({
  key: z.string(),
  label: z.string(),
  category: z.enum(['not_started', 'active', 'successful', 'unsuccessful']),
})
export const materialRecordSchema = versionedRecordSchema.extend({
  name: z.string(),
  baseUnit: z.string(),
  critical: decimalStringSchema,
  unitCost: decimalStringSchema,
})
export const productRecordSchema = versionedRecordSchema.extend({
  name: z.string(),
  code: z.string(),
  unit: z.string(),
  basePrice: decimalStringSchema,
})
export const snapshotSchema = z.object({
  data: z.record(z.string(), z.unknown()),
  state: z.record(z.string(), z.unknown()),
})
export type Snapshot = z.infer<typeof snapshotSchema>
